import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router';
import {
  getGTMContainerForPath,
  initializeGTM,
  validateGTMContainer,
} from './gtm';

export const GTMInitializer = ({ children }: { children: ReactNode }) => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GTM on mount with the initial route
    const containerId = getGTMContainerForPath(location.pathname);
    initializeGTM(containerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Validate on route changes
    validateGTMContainer(location.pathname);
  }, [location.pathname]);

  return <>{children}</>;
};
